import { useEffect, useState } from "react";
import TermsOfUseContainer from "./TermOfUseContainer";



function TermsOfUse(props) {
    const [policies, setPolicies] = useState();

    useEffect(() => {
        // requester.getAllPolicies((result) => {
        //     setPolicies(result.data);
        // })

    }, []);

    return (
        <TermsOfUseContainer />
    );
}

export default TermsOfUse;